import { useEffect, useState } from "react";
import { BellRing, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ExpiryReminderDaysCard = () => {
  const [days, setDays] = useState(null);
  const [def, setDef] = useState([]);
  const [add, setAdd] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/agency-settings/expiry-reminders").then(({ data }) => { setDays(data.days); setDef(data.default); }).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const addDay = () => {
    const n = parseInt(add, 10);
    if (!n || n < 1 || n > 120) return toast.error("Inserisci un numero di giorni tra 1 e 120");
    setDays((d) => [...new Set([...d, n])].sort((a, b) => b - a)); setAdd("");
  };
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/agency-settings/expiry-reminders", { days }); setDays(data.days); toast.success("Giorni dei promemoria salvati"); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 mt-6 p-5" data-testid="expiry-reminders-section">
      <h2 className="text-lg font-semibold text-slate-900 flex items-center gap-2"><BellRing className="h-5 w-5 text-orange-500" /> Promemoria automatici di scadenza</h2>
      <p className="text-xs text-slate-500 mt-0.5">Ogni mattina alle 9:00 il cliente riceve un&apos;email quando mancano esattamente questi giorni alla scadenza (polizza o rata).</p>
      {!days ? <Loader2 className="h-5 w-5 animate-spin text-slate-400 mt-3" /> : (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          {days.map((d) => (
            <span key={d} className="inline-flex items-center gap-1 h-8 pl-3 pr-1.5 rounded-full bg-orange-50 border border-orange-200 text-orange-900 text-sm font-semibold" data-testid={`expiry-day-${d}`}>
              {d} gg
              <button type="button" onClick={() => setDays(days.filter((x) => x !== d))} className="h-5 w-5 rounded-full hover:bg-orange-200 inline-flex items-center justify-center" data-testid={`expiry-day-remove-${d}`}><X className="h-3 w-3" /></button>
            </span>
          ))}
          <Input type="number" min={1} max={120} value={add} onChange={(e) => setAdd(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addDay()} placeholder="giorni" className="h-8 w-24" data-testid="expiry-day-input" />
          <Button size="sm" variant="outline" onClick={addDay} data-testid="expiry-day-add">Aggiungi</Button>
          <Button size="sm" variant="ghost" onClick={() => setDays(def)} data-testid="expiry-day-reset">Ripristina predefiniti</Button>
          <Button size="sm" onClick={save} disabled={saving || !days.length} data-testid="expiry-days-save">{saving && <Loader2 className="h-4 w-4 animate-spin mr-1" />}Salva</Button>
        </div>
      )}
    </div>
  );
};
